import { BOOKING_GUEST_INVALID_COUPON_CODE, CAMPER_DELETED, CAMPER_NOT_FOUND, CAMPER_PRICE_INVALID_DOCUMENTS, INVALID_PLACE, SEARCH_INVALID_PAGE, PAYMENT_CARD_EXPIRES_BEFORE_BOOKING_END } from '~/utils/error/errorFingerprints'

// Fingerprints that we do not want to report to sentry
export const isFingerprintExcludedFromSentry = (fingerprint: string): boolean => {
  return [
    CAMPER_NOT_FOUND,
    CAMPER_DELETED,
    SEARCH_INVALID_PAGE,
    CAMPER_PRICE_INVALID_DOCUMENTS,
    INVALID_PLACE,
    BOOKING_GUEST_INVALID_COUPON_CODE,
    PAYMENT_CARD_EXPIRES_BEFORE_BOOKING_END,
  ].includes(fingerprint)
}
